if (!customElements.get('misi-card-gallery')) {
  customElements.define('misi-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-index]')];
      this.index = 0;
      this.show(0);
      if (this.slides.length < 2) return;
      this.classList.add('is-interactive');
      this.dots.forEach(dot => dot.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation(); this.show(Number(dot.dataset.index));
      }));
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation();
        this.show((this.index + Number(button.dataset.direction) + this.slides.length) % this.slides.length);
      }));
      this.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault(); this.show((this.index + (e.key === 'ArrowRight' ? 1 : -1) + this.slides.length) % this.slides.length);
          this.dots[this.index].focus();
        }
      });
      this.addEventListener('touchstart', e => {
        this.start = {x:e.touches[0].clientX,y:e.touches[0].clientY};
      }, {passive:true});
      this.addEventListener('touchcancel',()=>{this.start=undefined},{passive:true});
      this.addEventListener('touchend', e => {
        if (!this.start) return;
        const dx=e.changedTouches[0].clientX-this.start.x;
        const dy=e.changedTouches[0].clientY-this.start.y;
        this.start = undefined;
        if (Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)*1.5) {
          this.swipedAt=Date.now(); this.show((this.index+(dx<0?1:-1)+this.slides.length)%this.slides.length);
        }
      }, {passive:true});
      this.querySelector('a').addEventListener('click', e => {
        if (Date.now()-this.swipedAt<500) e.preventDefault();
      });
    }
    show(index) {
      this.index=index;
      this.slides.forEach((slide,i)=>{
        slide.classList.toggle('is-active',i===index);
        slide.setAttribute('aria-hidden',String(i!==index));
      });
      const start=Math.max(0,Math.min(index-2,this.dots.length-5));
      this.dots.forEach((dot,i)=>{
        dot.setAttribute('aria-pressed',String(i===index));
        dot.hidden=this.dots.length>5 && (i<start || i>=start+5);
        dot.classList.toggle('is-edge',this.dots.length>5 && ((i===start && start>0)||(i===start+4 && start+5<this.dots.length)));
      });
    }
  });
}

if (!customElements.get('misi-mobile-buy')) {
 customElements.define('misi-mobile-buy',class extends HTMLElement {
  connectedCallback(){
   this.source=document.getElementById(this.dataset.sourceId);
   if(!this.source || !window.IntersectionObserver || this.ready) return;
   this.ready=true;
   this.button=this.querySelector('button');
   this.button.addEventListener('click',()=>{
    const form=this.source.closest('form');
    if(form && !form.reportValidity()){form.scrollIntoView({behavior:'smooth',block:'center'});return}
    if(!this.source.disabled) this.source.click();
   });
   this.refresh=()=>{
    const blocked=!!document.querySelector('cart-drawer.active,cart-notification.active,product-modal[open]');
    const visible=!!this.pastButton && !blocked;
    this.hidden=!visible;this.classList.toggle('is-visible',visible);this.button.tabIndex=visible?0:-1;
   };
   this.sync=()=>{
    this.button.disabled=this.source.disabled;
    this.button.textContent=this.source.querySelector('span')?.textContent.trim() || this.source.textContent.trim();
   };
   this.sync();
   this.mutation=new MutationObserver(this.sync);
   this.mutation.observe(this.source,{attributes:true,childList:true,subtree:true,characterData:true});
   this.observer=new IntersectionObserver(entries=>{
    const entry=entries[0];
    this.pastButton=!entry.isIntersecting && entry.boundingClientRect.bottom<0;this.refresh();
   });this.observer.observe(this.source);
   this.overlayObserver=new MutationObserver(this.refresh);
   document.querySelectorAll('cart-drawer,cart-notification,product-modal').forEach(el=>this.overlayObserver.observe(el,{attributes:true,attributeFilter:['class','open']}));
  }
  disconnectedCallback(){this.observer?.disconnect();this.mutation?.disconnect();this.overlayObserver?.disconnect();this.ready=false}
 });
}
